
import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum } from "../../../../components2/YhFormBox/Types"
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { useUserModel } from "../userModel"
import useMdmModel from "../../../../model/mdmModel"
import { useNavModel } from "../../../../model/navModel";
import { DetailType } from "../../../../types/FmsEnums";
import { IUserSearch, IUserParams, IUserInsert, IUserUpdata, IUserDisable, IUserDetail } from "../userTypes"
import { setTitle, loadDictParam } from "../../../../utils/utils"
const UserDetail = () => {
    const [form] = Form.useForm();
    const { mdmCatalog, mdmBranch, mdmSourceApp, mdmOrgan, dict } = useMdmModel();
    const { selectedNavId, addNav, closeNav, getSelectedNavState, replaceNav, findNav } = useNavModel()
    const { addParam, selectedRow, userTypeList, setAddParam, setSelectedRow, setSelectedRowKeys, updataAddParam, updataEditParam, insertDetail, updataDetail, setUserTypeList } = useUserModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const { id, pageParams } = modes
    const { mode, id: ids } = pageParams
    useEffect(() => {
        console.log(addParam)
        if (mode == DetailType.add) {
            form.setFieldsValue(addParam)
        } else if (mode == DetailType.edit || mode == DetailType.look) {
            form.setFieldsValue(selectedRow[0])
        }
    }, [addParam, selectedRow[0]])
    const onFinish = (values: IUserInsert | IUserUpdata) => {
        if (mode == DetailType.add) {
            insertDetail(values as IUserInsert).then(res => {
                if (res) close();
            })
        } else if (mode == DetailType.edit) {
            updataDetail(values as IUserDetail).then(res => {
                if (res) close();
            })
        }
    }
    // useEffect(() => {
    //     return () => {
    //         const findInsert = findNav("2-4-1")
    //         const findEdit = findNav("2-4-2")
    //         !!!findInsert && setAddParam({});
    //         !!!findEdit && setSelectedRowKeys([]) && setSelectedRow([]);
    //     }
    // }, [selectedNavId])
    useEffect(() => {
        setUserTypeList(loadDictParam('user-type', dict))
    }, [])
    const close = () => {
        replaceNav(selectedNavId, "2-4")
    }
    const items = [
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "分支编码",
            labelCol: { span: 6 },
            fieldName: "branch",
            options: mdmBranch
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "版本号",
            labelCol: { span: 6 },
            fieldName: "ver",
            disable: true,
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "用户编码",
            labelCol: { span: 6 },
            fieldName: "code",
            disable: mode == DetailType.edit,
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "用户名称",
            labelCol: { span: 6 },
            fieldName: "name",
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "用户类型",
            labelCol: { span: 6 },
            fieldName: "userTypeCode",
            options: userTypeList,
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "员工工号",
            labelCol: { span: 6 },
            fieldName: "staffId",
        },
        {
            type: FormItemTypeEnum.Datepicker,
            span: 8,
            fieldLabel: "入职日期",
            labelCol: { span: 6 },
            fieldName: "birthday",
        },
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "性别",
            labelCol: { span: 6 },
            fieldName: "gender",
            options: [{ key: "1", value: 1, label: "男" }, { key: "2", value: 2, label: "女" }],
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "邮箱",
            labelCol: { span: 6 },
            fieldName: "email",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "电话",
            labelCol: { span: 6 },
            fieldName: "phone",
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 16,
            fieldLabel: "备注",
            labelCol: { span: 3 },
            fieldName: "note",
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 8,
            fieldLabel: "状态",
            labelCol: { span: 6 },
            fieldName: "enable",
            valuePropName: "checked",
            checkedChildren: "启用",
            unCheckedChildren: "禁用"
        },
    ]
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}用户</div>
    const reset = () => {
        form.resetFields()
        if (mode == DetailType.add) {
            setAddParam({})
        } else if (mode == DetailType.edit) {
            form.setFieldsValue({ code: selectedRow[0].code })
            setSelectedRow([{ code: selectedRow[0].code }])
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.submit()}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => reset()}
        >重置</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => close()}
        >取消</Button>
    </>
    return <Form
        form={form}
        onValuesChange={mode == DetailType.add ? updataAddParam : updataEditParam}
        onFinish={onFinish}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action} IclassName="p-20" />
    </Form>
}
export default UserDetail